import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom'; // Import Navigate for redirect
import './Profile.css';

const Profile = () => {
  const { currentUser, updateUserPhoto } = useAuth();
  
  // Initialize 'preview' safely, checking if currentUser exists first
  const [newPhoto, setNewPhoto] = useState(null);
  const [preview, setPreview] = useState(currentUser ? currentUser.profilePhoto : null);
  
  // --- ADDED: Loading and Error states ---
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Your file handler is perfect, no changes needed.
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // --- ADDED: Clear messages when a new file is picked ---
    setMessage('');
    setError('');

    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX_WIDTH = 200;
        const MAX_HEIGHT = 200;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        const dataUrl = canvas.toDataURL(file.type);
        setNewPhoto(dataUrl);
        setPreview(dataUrl);
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  // --- FIX: Made handleSubmit async ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!newPhoto) {
      setError('Please select a new photo to upload.');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      // --- FIX: Await the async function ---
      await updateUserPhoto(newPhoto);
      setMessage('Profile photo updated successfully!');
      setNewPhoto(null); // Clear the selected file
    } catch (err) {
      console.error(err);
      setError(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // --- ADDED: Handle loading or non-logged-in user ---
  if (!currentUser) {
    // This can happen if the page is accessed directly
    // or if AuthContext is still loading.
    // A ProtectedRoute should ideally prevent this, but it's good practice.
    return <Navigate to="/login" />;
  }

  return (
    <div className="profile-container">
      <h2>Your Profile</h2>
      <div className="profile-info">
        <img 
          // --- FIX: Added a default placeholder ---
          src={preview || 'https://via.placeholder.com/150?text=No+Photo'} 
          alt="Profile" 
          className="profile-photo-preview" 
        />
        {/* Safely access properties */}
        <p><strong>First Name:</strong> {currentUser.firstName || 'Not set'}</p>
        <p><strong>Last Name:</strong> {currentUser.lastName || 'Not set'}</p>
        <p><strong>Username:</strong> {currentUser.username || 'Not set'}</p>
        <p><strong>Email:</strong> {currentUser.email}</p>
      </div>
      
      <form onSubmit={handleSubmit} className="profile-form">
        <label htmlFor="photo-upload">Change Profile Photo:</label>
        <input 
          id="photo-upload"
          type="file" 
          accept="image/*" 
          onChange={handleFileChange} 
          disabled={loading} // Disable while uploading
        />
        <button type="submit" disabled={loading || !newPhoto}>
          {loading ? 'Uploading...' : 'Save Photo'}
        </button>
      </form>
      
      {/* Show success or error messages */}
      {message && <p className="profile-message success">{message}</p>}
      {error && <p className="profile-message error">{error}</p>}
    </div>
  );
};

export default Profile;